var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1156 4.54224C14.4681 4.18985 14.6662 3.71188 14.6662 3.21347C14.6663 2.71506 14.4683 2.23704 14.116 1.88457C13.7636 1.5321 13.2856 1.33405 12.7872 1.33398C12.2888 1.33392 11.8108 1.53185 11.4583 1.88424L2.56096 10.7836C2.40618 10.9379 2.29171 11.1279 2.22763 11.3369L1.34696 14.2382C1.32973 14.2959 1.32843 14.3571 1.3432 14.4155C1.35796 14.4738 1.38824 14.5271 1.43083 14.5696C1.47341 14.6121 1.52671 14.6423 1.58507 14.657C1.64343 14.6716 1.70467 14.6702 1.7623 14.6529L4.6643 13.7729C4.87308 13.7094 5.06308 13.5956 5.21763 13.4416L14.1156 4.54224Z",
    stroke: "#676F7E",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.33398L12.6667 6.00065",
    stroke: "#676F7E",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.35cf6ad6fc2b9d05487cd993c462995d.svg";
export { ForwardRef as ReactComponent };